var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"reset-password-page"},[(!_vm.getError)?[_c('reset-password-form')]:[_c('Error')]],2)}
var staticRenderFns = []

export { render, staticRenderFns }